import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { HardHat, ArrowLeft } from 'lucide-react';
import { useToast } from '../hooks/use-toast';
import { useAuth } from '../context/AuthContext';

const MitarbeiterLoginPage = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const { loginMitarbeiter } = useAuth();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    const result = await loginMitarbeiter(formData.email, formData.password);
    
    if (result.success) {
      toast({
        title: "Login erfolgreich!",
        description: "Willkommen in der Elite-Schmiede"
      });
      navigate('/elite-schmiede');
    } else {
      toast({
        title: "Login fehlgeschlagen",
        description: result.error || "Bitte überprüfen Sie Ihre Zugangsdaten",
        variant: "destructive"
      });
    }
    
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-gray-900 to-black flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="flex items-center justify-center gap-2 mb-8 cursor-pointer" onClick={() => navigate('/')}>
          <img src="/assets/smartvolt-logo.png" alt="Smartvolt Academy" className="h-16" />
        </div>

        <Card className="bg-gradient-to-br from-gray-900 to-black border-yellow-600/20">
          <CardHeader className="text-center">
            <div className="flex justify-center mb-4">
              <div className="h-16 w-16 rounded-full bg-yellow-500/20 flex items-center justify-center">
                <HardHat className="h-8 w-8 text-yellow-500" />
              </div>
            </div>
            <CardTitle className="text-2xl text-white">Elite-Schmiede</CardTitle>
            <CardDescription className="text-gray-400">Mitarbeiter-Login für Ihre Schulungen</CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Label htmlFor="email" className="text-gray-300">E-Mail</Label>
                <Input
                  id="email"
                  type="email"
                  required
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                  className="bg-gray-800 border-yellow-600/20 text-white focus:border-yellow-500"
                  placeholder="mitarbeiter@firma.de"
                />
              </div>
              <div>
                <Label htmlFor="password" className="text-gray-300">Passwort</Label>
                <Input
                  id="password"
                  type="password"
                  required
                  value={formData.password}
                  onChange={(e) => setFormData({...formData, password: e.target.value})}
                  className="bg-gray-800 border-yellow-600/20 text-white focus:border-yellow-500"
                  placeholder="Ihr Passwort"
                />
              </div>
              <Button type="submit" disabled={loading} className="w-full bg-gradient-to-r from-yellow-600 to-yellow-500 text-black font-semibold hover:from-yellow-500 hover:to-yellow-400">
                {loading ? 'Anmeldung läuft...' : 'Als Mitarbeiter anmelden'}
              </Button>
            </form>
            <div className="mt-6 pt-4 border-t border-gray-800">
              <Button 
                variant="ghost" 
                className="w-full text-gray-400 hover:text-white"
                onClick={() => navigate('/login')}
              >
                <ArrowLeft className="h-4 w-4 mr-2" />
                Zurück zum Firmen-Login
              </Button>
            </div>
          </CardContent>
        </Card>

        {/* Info text */}
        <p className="text-center text-gray-500 text-sm mt-4">
          Sie sind Betriebsinhaber? <span className="text-yellow-500 cursor-pointer hover:underline" onClick={() => navigate('/login')}>Hier anmelden</span>
        </p>
      </div>
    </div>
  );
};

export default MitarbeiterLoginPage;
